import { BonusPeriodModel } from 'api-hooks/bonus';
import * as Yup from 'yup';

export const SaleConfigurationFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    department: Yup.string().default(''),
    type: Yup.string().default(''),
    operatorSalesBonus: Yup.number()
      .default(0)
      .when('type', {
        is: 'percentage',
        then: Yup.number().default(0).max(100),
      }),
    leadBonus: Yup.number()
      .default(0)
      .when('type', {
        is: 'percentage',
        then: Yup.number().default(0).max(100),
      }),
    customId: Yup.string().default(''),
  });

export const EmployeePerformanceConfigurationFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    grade: Yup.string().default(''),
    percentage: Yup.number().default(0).max(100),
    count: Yup.number().default(0),
    dividenPercentage: Yup.number().default(0).max(100),
    customId: Yup.string().default(''),
  });

export const EmployeeJobLevelConfigurationFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    jobLevel: Yup.string().default(''),
    percentage: Yup.number().default(0).max(100),
    count: Yup.number().default(0),
    dividenPercentage: Yup.number().default(0).max(100),
    customId: Yup.string().default(''),
  });

export const EmployeeFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    role: Yup.string(),
    previousGrade: Yup.string(),
    employeeId: Yup.string().default(''),
    jobLevel: Yup.string().default(''),
    grade: Yup.string().default(''),
    previousJobLevel: Yup.string(),
    customId: Yup.string().default(''),
  });

export const BonusPeriodFormSchema = () =>
  Yup.object({
    name: Yup.string().default(''),
    startAt: Yup.date().nullable().default(null),
    endAt: Yup.date().nullable().default(null),
    issueAt: Yup.date().nullable().default(null),
    profitPercentage: Yup.number().default(0).max(100),
    saleConfigurations: Yup.array(SaleConfigurationFormSchema()).default([]),
    employeePerformanceConfigurations: Yup.array(
      EmployeePerformanceConfigurationFormSchema(),
    ).default([]),
    employeeJobLevelConfigurations: Yup.array(
      EmployeeJobLevelConfigurationFormSchema(),
    ).default([]),
    employees: Yup.array(EmployeeFormSchema()).default([]),
  });

export type BonusPeriodFormType = Yup.InferType<
  ReturnType<typeof BonusPeriodFormSchema>
> & { bonusPeriod?: BonusPeriodModel };

export type EmployeeFormType = Yup.InferType<
  ReturnType<typeof EmployeeFormSchema>
>;

export type EmployeeJobLevelConfigurationFormType = Yup.InferType<
  ReturnType<typeof EmployeeJobLevelConfigurationFormSchema>
>;

export type EmployeePerformanceConfigurationFormType = Yup.InferType<
  ReturnType<typeof EmployeePerformanceConfigurationFormSchema>
>;

export type SaleConfigurationFormType = Yup.InferType<
  ReturnType<typeof SaleConfigurationFormSchema>
>;
